var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('combo-detail',{attrs:{"data-in-cart":_vm.cart,"click-addcart":_vm.addCart},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }